import { z } from "zod";
// ============ Worksheet Meta ============
export const worksheetMetaSchema = z.object({
    name: z.string(),
    rowCount: z.number(),
    columns: z.array(z.string()),
});
// ============ Excel Upload ============
export const excelUploadSchema = z.object({
    id: z.string().uuid(),
    organizationId: z.string().uuid(),
    userId: z.string().uuid(),
    name: z.string(),
    originalFileName: z.string(),
    storagePath: z.string(),
    storageType: z.enum(["local", "s3"]),
    fileHash: z.string(),
    fileSizeBytes: z.number(),
    worksheets: z.array(worksheetMetaSchema),
    status: z.enum(["processing", "ready", "error"]),
    errorMessage: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
// ============ Request Schemas ============
export const uploadExcelBodySchema = z.object({
    name: z.string().min(1).max(255),
});
export const readExcelSheetParamsSchema = z.object({
    id: z.string().uuid(),
    sheetName: z.string(),
});
export const readExcelSheetQuerySchema = z.object({
    maxRows: z.coerce.number().int().min(1).max(10000).default(500),
    range: z.string().optional(),
});
// ============ Response Schemas ============
export const uploadExcelResponseSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    status: z.enum(["processing", "ready", "error"]),
    worksheets: z.array(worksheetMetaSchema),
});
export const excelUploadListResponseSchema = z.array(excelUploadSchema);
export const readExcelSheetResponseSchema = z.object({
    columns: z.array(z.string()),
    rows: z.array(z.record(z.string(), z.unknown())),
    totalRows: z.number(),
});
